import * as React from "react";
import api from "./Config/HttpFeasibility";
import { useTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import es from 'date-fns/locale/es';
import TimetableIcon from 'mdi-react/TimetableIcon';
import { Field, reduxForm } from 'redux-form';
import renderSelectField from '../../../shared/components/form/Select';
import { useHistory } from "react-router-dom";
import Modal from '../../../shared/components/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const AddFeasibility = ({ location }) => {
    const { t } = useTranslation('common');
    const history = useHistory();

    const [allSponsors, setAllSponsors] = React.useState([]);
    const [optionsSponsors, setOptionsSponsors] = React.useState([]);
    const [date, setDate] = React.useState(null);
    const [dateFormat, setDateFormat] = React.useState(null);
    const [sponsor, setSponsor] = React.useState(null);
    const [studyName, setStudyName] = React.useState(null);
    const [acronym, setAcronym] = React.useState(null);
    const [contact, setContact] = React.useState(null);
    const [email, setEmail] = React.useState(null);

    const [showModal, setShowModal] = React.useState(false);
    const [messageModal, setMessageModal] = React.useState(null);
    const [colorModal, setColorModal] = React.useState("success");

    const handlerFocus = (e) => {
        e.preventDefault();
        let _input = e.currentTarget;
        let _parent = _input.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_input.value.length === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const handleFocusPicker = (e) => {
        e.preventDefault();
        let _input = e.currentTarget;
        let _parent = _input.parentNode.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_input.value.length === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const handleFocusSelect = (e) => {
        e.preventDefault();
        let _select = e.currentTarget;
        let _parent = _select.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_select.selectedIndex === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const validateDate = () => {
        if (date == null || date.length < 1) {
            openModal(false, t('msg.date_require'));
            return false;
        } else {
            return true;
        }
    }

    const validateSponsor = () => {
        if (sponsor == null || sponsor.length < 1) {
            openModal(false, t('msg.sponsor_require'));
            return false;
        } else {
            return true;
        }
    }

    const validateName = () => {
        if (studyName == null || studyName.length < 1) {
            openModal(false, t('msg.study_name_require'));
            return false;
        } else {
            return true;
        }
    }

    const validateAcronym = () => {
        if (acronym == null || acronym.length < 1) {
            openModal(false, t('msg.acronym_require'));
            return false;
        } else {
            return true;
        }
    }

    const validateContact = () => {
        if (contact == null || contact.length < 1) {
            openModal(false, t('msg.contact_require'));
            return false;
        } else {
            return true;
        }
    }

    const validateEmail = () => {
        if (email == null || email.length < 1) {
            openModal(false, t('msg.email_require'));
            return false;
        } else {
            return true;
        }
    }

    const validate = async () => {
        if (validateDate()) {
            if (validateSponsor()) {
                if (validateName()) {
                    if (validateAcronym()) {
                        if (validateContact()) {
                            if (validateEmail()) {
                                sendRequest();
                            }
                        }
                    }
                }
            }
        }
    }

    const sendRequest = async () => {
        let _params = {
            "nombre_estudio": studyName,
            "acronimo": acronym,
            "fecha": dateFormat,
            "contacto": contact,
            "mail": email,
            "id_patrocinador": sponsor
        };
        let _data = await api.createFeasibility(_params);

        if (_data.existe) {
            openModal(true, t(_data.contenido));
        } else {
            openModal(false, t(_data.contenido));
        }
    }

    const listSponsors = async (data) => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}factibilidad/listar_patrocinadores`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => response.json()).then(data => {
            setAllSponsors(data);
            SponsorList(data);
        }).catch((error) => {
            setAllSponsors([]);
        });
    }

    const SponsorList = (data) => {
        let _rows = [];
        data.forEach(sponsor => {
            _rows.push({ value: sponsor.id_tercero, label: sponsor.nombre });
        });
        setOptionsSponsors(_rows);
    }

    const changeOptionSponsor = (opt) => {
        setSponsor(opt.value);
    }

    React.useEffect(() => {
        listSponsors();
    }, []);

    const openModal = (success, message) => {
        if (success == true) {
            setColorModal("success");
        }
        else {
            setColorModal("danger");
        }
        setShowModal(true);
        setMessageModal(message);
    }

    const regresar = () => {
        let _url = process.env.PUBLIC_URL + "/clinical-studio/search";
        history.push({
            pathname: _url
        });
    }

    const handleOkModal = () => {
        setShowModal(false);
        if (colorModal == "success") {
            regresar();
        }
    }


    return (<Container>
        <Row>

            <Col md={12}>
                <h3 className="page-title center-title">{t('btn.add')} {t('feasibility.title')}</h3>
                <Col md={2}>
                    <div className='top_info_buttons_hc'>
                        <div>
                            <Tooltip
                                title="Regresar al Listado de Estudios Clinicos"
                            >
                                <IconButton
                                    aria-label="upload picture"
                                    component="span"
                                    className='tooltip-top'
                                    onClick={() => {
                                        regresar();
                                    }}
                                >
                                    <ArrowBackIcon style={{ color: '#153365' }} />
                                </IconButton>
                            </Tooltip>
                            <span style={{ marginLeft: '0.25em' }}>Regresar al Listado de Estudios Clinicos</span>
                        </div>
                    </div>
                </Col>
            </Col>
        </Row>

        <Card className="card--flex">
            <CardBody className="width_static">

                <Row>
                    <Col md={3}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <ThemeProvider theme={defaultMaterialTheme}>
                                <DatePicker
                                    disableFuture
                                    openTo="date"
                                    label="Fecha Inicial"
                                    variant="inline"
                                    autoOk={true}
                                    views={["year", "month", "date"]}
                                    value={date}
                                    onChange={(value) => {
                                        let fecha_seleccionada = moment(value).format('YYYY/MM/DD');
                                        setDate(value);
                                        setDateFormat(fecha_seleccionada);
                                    }}
                                    className='medical-material-form__field'
                                    animateYearScrolling
                                    format="yyyy/MM/D"
                                />
                            </ThemeProvider>
                        </MuiPickersUtilsProvider>
                    </Col>
                    <Col md={3}>
                        <TextField
                            label="Patrocinador"
                            value={sponsor}
                            onChange={(event) => {
                                setSponsor(event.target.value);
                            }}
                            select
                            style={{ minWidth: '100%', maxWidth: '100%' }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                        >
                            {optionsSponsors.map((item, index) => {
                                return (<MenuItem key={item.value} value={item.value}>
                                    {item.label}
                                </MenuItem>)
                            })}
                        </TextField>
                    </Col>
                    <Col md={3}>
                        <TextField
                            label="Nombre del Estudio"
                            value={studyName}
                            onChange={(event) => {
                                setStudyName(event.target.value);
                            }}
                            style={{ minWidth: '100%', maxWidth: '100%' }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                        />
                    </Col>
                    <Col md={3}>
                        <TextField
                            label="Acronimo del Estudio"
                            value={acronym}
                            onChange={(event) => {
                                setAcronym(event.target.value);
                            }}
                            style={{ minWidth: '100%', maxWidth: '100%' }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                        />
                    </Col>
                    <Col md={3}>
                        <TextField
                            label="Contacto"
                            value={contact}
                            onChange={(event) => {
                                setContact(event.target.value);
                            }}
                            style={{ minWidth: '100%', maxWidth: '100%' }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                        />
                    </Col>
                    <Col md={3}>
                        <TextField
                            label="Correo Electronico"
                            value={email}
                            onChange={(event) => {
                                setEmail(event.target.value);
                            }}
                            style={{ minWidth: '100%', maxWidth: '100%' }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                        />
                    </Col>
                </Row>
                <br/>
                <ButtonToolbar className="form__button-toolbar">
                    <Button color="primary" type="button"
                        onClick={() => validate()}>
                        {t('btn.save')}
                    </Button>
                    <Button type="button"
                        onClick={() => history.goBack()}>
                        {t('btn.cancel')}
                    </Button>
                </ButtonToolbar>
            </CardBody>
        </Card>

        <Modal
            color={colorModal}
            title={messageModal}
            modal={showModal}
            onOk={() => handleOkModal()}
            toggle={() => setShowModal(false)}
        />

    </Container>);
}

export default reduxForm({
    form: 'horizontal_form_feasibility_add', // a unique identifier for this form
})(AddFeasibility);